import { UnidadeDistribuidorRepository } from "../repository/unidade_distribuidor_repository";

export class UnidadeDistribuidorService {
	constructor() {
		this.unidadeDistribuidorRepository = new UnidadeDistribuidorRepository();
	}

	async save(data) {
		return await this.unidadeDistribuidorRepository.save(data);
	}

	async update(data) {
		return await this.unidadeDistribuidorRepository.update(data);
	}

	async getAll(page, limit, search) {
		return await this.unidadeDistribuidorRepository.getAll(page, limit, search);
	}

	async getById(id) {
		return await this.unidadeDistribuidorRepository.getById(id);
	}

	async delete(id) {
		return await this.unidadeDistribuidorRepository.delete(id);
	}

	async changeVisibility(id) {
		return await this.unidadeDistribuidorRepository.changeVisibility(id);
	}

	async getByEmpresaDistribuidor(empresaDistribuidorId) {
		return await this.unidadeDistribuidorRepository.getByEmpresaDistribuidor(empresaDistribuidorId);
	}
}
